(function(){if(window.__mmHomeReveal)return;window.__mmHomeReveal=1;
  function go(){
    var els=document.querySelectorAll('.mm-home .r:not(.v)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('v');});return;}
    var io=new IntersectionObserver(function(ents){
      ents.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('v'); io.unobserve(en.target); } });
    },{rootMargin:'0px 0px -8% 0px',threshold:0.08});
    els.forEach(function(e){io.observe(e);});
  }
  if(document.readyState!=='loading'){go();}else{document.addEventListener('DOMContentLoaded',go);}
})();
